import styled, { keyframes } from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const GlobalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); // 반투명 검정색
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const MainContent = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;

  > .left {
    flex-shrink: 0;
    height: 100vh;
    overflow: hidden;
  }

  > .right {
    flex: 1;
    min-width: 0;
    height: 100vh;
    overflow-x: auto;
    overflow-y: auto;

    > .content {
      width: 100%;
      height: 100%;
      min-height: 0;
    }
  }
`;

export const MobileMainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > .top {
    width: 100%;
    overflow-x: hidden;

    > .content {
      width: 100%;
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); // 반투명 검정색
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.3); // 회색 테두리
  border-radius: 50%;
  border-top-color: #fff; // 흰색 부분
  width: 50px;
  height: 50px;
  animation: ${rotate} 1s linear infinite;
`;
